type TypographyValuesType = {
  [key: string]: 1 | 2 | 3 | 4 | 5;
};

export const spanCols: { [key: string]: number } = {
  xs: 24,
  sm: 24,
  md: 12,
  lg: 6,
  xl: 6,
  xxl: 6,
  xxxl: 6,
};

export const spanTwoCols: { [key: string]: number } = {
  xs: 24,
  sm: 24,
  md: 24,
  lg: 12,
  xl: 12,
  xxl: 12,
};

export const spanThreeCols: { [key: string]: number } = {
  xs: 24,
  sm: 24,
  md: 24,
  lg: 12,
  xl: 8,
  xxl: 8,
  xxxl: 8,
};

export const gutterValues: { [key: string]: [number, number] } = {
  xs: [16, 0],
  sm: [16, 0],
  md: [16, 0],
  lg: [16, 0],
  xl: [16, 0],
  xxl: [16, 8],
  xxxl: [16, 8],
};

export const gutterValues16_8: { [key: string]: [number, number] } = {
  xs: [16, 8],
  sm: [16, 8],
  md: [16, 8],
  lg: [16, 8],
  xl: [16, 8],
  xxl: [16, 8],
};

export const screenFlags: { [key: string]: boolean } = {
  xs: true,
  sm: true,
  md: true,
  lg: false,
  xl: false,
  xxl: false,
};

/** Has same values as screenFlags, but is used for assigning classes. We can overwrite keys in this object  */
export const cls: { [key: string]: boolean } = {
  ...screenFlags,
};

export const alignment: { [key: string]: string } = {
  xs: "baseline",
  sm: "baseline",
  md: "baseline",
  lg: "center",
  xl: "center",
  xxl: "center",
};

export const contentTabLayoutPosition: {
  [key: string]: "start" | "end" | "top" | "bottom" | undefined;
} = {
  xs: "start",
  sm: "start",
  md: "start",
  lg: "top",
  xl: "top",
  xxl: "top",
};

export const typographyValues: TypographyValuesType = {
  xs: 4,
  sm: 4,
  md: 3,
  lg: 3,
  xl: 3,
  xxl: 3,
};
